/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LessonsInputs */

const en_nav_lessons = /** @type {(inputs: Nav_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessons`)
};

const he_nav_lessons = /** @type {(inputs: Nav_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורים`)
};

/**
* | output |
* | --- |
* | "Lessons" |
*
* @param {Nav_LessonsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const nav_lessons = /** @type {((inputs?: Nav_LessonsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LessonsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_lessons(inputs)
	return he_nav_lessons(inputs)
});